export class MeiliSearchError extends Error {
    name = "MeiliSearchError";
}
